import styled from 'styled-components';
import Link from 'gatsby-link';
import { red, roboto, teko } from '../../../utils/theme';

import { tablet } from '../../../utils/breakpoints';

export const NavWrapper = styled.div`
  min-height: 93px;

  @media (max-width: ${tablet}px) {
    min-height: 80px;
  }
`;

export const Nav = styled.nav`
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 20px 0 20px 20px;
  width: 100%;
  position: fixed;
  z-index: 21;

  .nav__links {
    display: flex;
    align-items: center;
    background: white;

    .nav_links-container > .nav__link {
      padding: 0 15px;
    }

    &.share-button {
      ${roboto};
    }
  }

  .nav__link--active {
    &:after {
      display: none;
    }
    span {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        width: calc(100% - 3px);
        height: 4px;
        bottom: 4px;
        left: 0;
        background-color: ${red};
      }
    }
  }

  .nav__link-text {
    border-bottom: none;
    color: #093a9a;
    ${roboto};
    font-weight: 500;
    letter-spacing: 3px;
    font-size: 13px;
  }

  .nav_links-container {
    display: flex;
    align-items: center;
  }

  @media (max-width: 1028px) {
    .nav__link-text {
      font-size: 16px;
    }
    .nav_links-container {
      flex-direction: column;
      margin: 0 auto;
    }

    .nav__link--active {
      &:after {
        display: none;
      }
      span {
        position: relative;
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 4px;
          bottom: -9px;
          left: 0;
          background-color: ${red};
        }
      }
    }
  }
`;

export const NavMobileLinks = styled.div`
  .nav__mobile-links {
    box-shadow: none;
  }
`;

export const Logo = styled(Link)`
  width: 109px;
  height: 48px;
`;

export const SmallRow = styled.div`
  ${teko} a {
    font-size: 14px;
  }
`;

export const LargeRow = styled.div``;



// WEBPACK FOOTER //
// ./src/components/header/styles/header.style.js